import type {ExtensionAPI, CreateExtArgs} from '@wix/document-manager-core'

export interface AccessibilityExtensionAPI extends ExtensionAPI {
    accessibility: {
        visualFocus: {
            get(): boolean
            set(enabled: boolean): void
        }
        autoDomReorder: {
            get(): boolean
            set(enabled: boolean): void
        }
        skipToContent: {
            get(): boolean
            set(enabled: boolean): void
        }
        languageDirection: {
            isRTL(languageCode: string): boolean
            getSiteDirection(): string
            setSiteDirection(siteDirection: string): void
        }
    }
}

export interface AccessibilityCreateExtArgs extends CreateExtArgs {
    // Extension-specific context
}

export type LanguageDirection = 'ltr' | 'rtl'

export interface AccessibilitySettings {
    visualFocusDisabled?: boolean
    skipToContent?: boolean
    currentSiteDirection?: LanguageDirection
}

export interface ComponentPriorityFunction {
    (comp: any): number
}

export interface SortingPredicate {
    (comp1: any, comp2: any): number
}

export const RTL_LANGUAGES = [
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'ha',
    'he',
    'khw',
    'ks',
    'ku',
    'mzn',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi'
] as const

export type RTLLanguage = (typeof RTL_LANGUAGES)[number]

// View modes for reordering
export const VIEW_MODES = {
    DESKTOP: 'DESKTOP',
    MOBILE: 'MOBILE'
} as const

export type ViewMode = (typeof VIEW_MODES)[keyof typeof VIEW_MODES]

// Constants for accessibility settings
export const ACCESSIBILITY_SETTINGS_PATH = 'accessibilitySettings'
export const MASTER_PAGE_ID = 'masterPage'
